import React from 'react'
import Skeleton from 'react-loading-skeleton'

import styles from './styles.module.css'

const ActionBarSkeleton = () => {
  return <Skeleton width={'100%'} height={54} className={styles.skeleton} />
}

export default ActionBarSkeleton
